import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery, useGetStaffByEmailIdQuery, useGetCampusQuery } from "../../../../graphql/generated.tsx";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader.jsx";
import ReportCampusCard from "../../Components/ReportCampusCard.jsx";

const Reports = () => {
  const navigate = useNavigate();
  const [campus, setCampus] = useState([]);
  const email = JSON.parse(localStorage.getItem("user"))?.email;
  
  const { data: staffData, loading: staffLoading } = useGetStaffByEmailIdQuery({
    variables: { email },
  });

  const { data: campusDetails, loading: campusLoading } = useGetCampusQuery({
    variables: { id: staffData?.getStaffByEmailId?.campusId },
    skip: staffLoading || !staffData?.getStaffByEmailId?.campusId,
  });

  const { data, loading, error } = useGetAllCampusesQuery();
  const [Isload, setIsload] = useState(true);

  useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);
  
  useEffect(() => {
    // If staff has campus, redirect directly to their campus course reports
    if (campusDetails?.campus?.name && !campusLoading) {
      navigate(`/admin/reports/${campusDetails.campus.name}`);
    }
  }, [campusDetails, campusLoading, navigate]);

  useEffect(() => {
    if (data) {
      setCampus(data.allCampus);
    }
  }, [data]);
  
  if (loading || Isload || staffLoading || campusLoading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      </AdminLayout>
    );
  }
  
  return (
    <AdminLayout>
      <div className="p-10">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              Reports
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {campus.map((c) => (
            <ReportCampusCard key={c.id} to={`/admin/reports/${c.name}`} name={c.name} />
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default Reports;
